import { styled as r, Typography as a, Checkbox as h } from "@mui/material";
import n from "../../temp-lib/components/share/next/Image.js";
import m from "../assets/icon-checked.svg.js";
import l from "../assets/icon-unchecked.svg.js";
import { jsx as e, jsxs as p } from "react/jsx-runtime";
const s = {
  icon: "Checkbox-icon",
  iconGroup: "Checkbox-iconGroup"
}, k = r(a)`
  display: inline-block;
  flex-shrink: 0;
  font-size: 30px;
  height: 1em;
  position: relative;
  user-select: none;
  width: 1em;

  & .Checkbox-icon {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
  }
`, i = (c) => {
  const {
    checked: o,
    className: t
  } = c;
  return /* @__PURE__ */ p(k, {
    as: "span",
    className: `${s.iconGroup} ${t}`,
    children: [o && /* @__PURE__ */ e(n, {
      src: m,
      className: s.icon
    }), !o && /* @__PURE__ */ e(n, {
      src: l,
      className: s.icon
    })]
  });
}, C = (c) => {
  const {
    className: o
  } = c;
  return /* @__PURE__ */ e(h, {
    checkedIcon: /* @__PURE__ */ e(i, {
      checked: !0,
      className: o
    }),
    className: o,
    icon: /* @__PURE__ */ e(i, {
      className: o
    }),
    ...c
  });
};
export {
  C as default
};
//# sourceMappingURL=MuiCheckbox.js.map
